(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-menu-toggle]:not([data-bound])').forEach(button => {
      button.dataset.bound = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        menu?.classList.toggle('open', open);
      });
      menu?.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          menu.classList.remove('open');
          button.setAttribute('aria-expanded', 'false');
          button.focus();
        }
      });
    });
    root.querySelectorAll('[data-variant-select]:not([data-bound])').forEach(select => {
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const price = select.closest('.product-detail')?.querySelector('[data-product-price]');
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
      });
    });
    root.querySelectorAll('[data-newsletter-dialog]:not([data-bound])').forEach(dialog => {
      dialog.dataset.bound = 'true';
      let opener;
      const storageKey = 'bb-newsletter-dismissed-session-v2';
      const remember = () => { try { sessionStorage.setItem(storageKey, 'true'); } catch {} };
      dialog.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { remember(); opener?.focus(); });
      let dismissed = false;
      try { dismissed = sessionStorage.getItem(storageKey) === 'true'; } catch {}
      const isHome = document.body.classList.contains('template-index');
      const isNewsletterResponse = location.hash === '#NewsletterPopup';
      if (isNewsletterResponse || (isHome && !dismissed)) {
        let ready = false;
        const open = () => {
          if (!ready || document.visibilityState !== 'visible' || dialog.open) return;
          opener = document.activeElement;
          dialog.showModal();
          document.removeEventListener('visibilitychange', open);
        };
        document.addEventListener('visibilitychange', open);
        setTimeout(() => {
          ready = true;
          open();
        }, isNewsletterResponse ? 0 : Number(dialog.dataset.delay || 2000));
      }
    });
    root.querySelectorAll('[data-campaign]:not([data-bound])').forEach(initCampaign);
  }
  async function initCampaign(container) {
    container.dataset.bound = 'true';
    const message = container.querySelector('[data-campaign-message]');
    const choices = [...container.querySelectorAll('[data-campaign-choice]')];
    const dialog = container.querySelector('[data-campaign-dialog]');
    const form = container.querySelector('[data-campaign-form]');
    const error = container.querySelector('[data-claim-error]');
    const proxy = container.dataset.proxy;
    const disable = () => choices.forEach(button => { button.disabled = true; });
    disable();
    if (container.dataset.enabled !== 'true') return;
    if (!proxy || !proxy.startsWith('/apps/') || proxy.includes('..') || proxy.includes('?') || proxy.includes('#')) {
      message.textContent = 'Die Aktion ist noch nicht freigeschaltet.';
      return;
    }
    let state;
    let selected;
    let previousFocus;
    const request = async (path, options = {}) => {
      const response = await fetch(proxy.replace(/\/$/, '') + path, {
        credentials: 'same-origin', cache: 'no-store', ...options,
        headers: {'Accept': 'application/json', ...options.headers}
      });
      const contentType = response.headers.get('content-type') || '';
      if (!contentType.includes('application/json')) throw new Error('UNAVAILABLE');
      const data = await response.json();
      if (!response.ok) throw new Error(data.code || 'UNAVAILABLE');
      return data;
    };
    const messages = {
      before: 'Die Gratis-Bun-Aktion startet am 08.11.2026. Heute wird kein Voucher ausgestellt.',
      active: 'Wähle deinen Bun. Erst eine erfolgreich abgeschlossene kostenlose Bestellung sichert deinen Voucher.',
      sold_out: 'Alle 300 kostenlosen Buns sind vergeben. Bereits bestätigte Voucher bleiben am Aktionstag einlösbar.',
      expired: 'Die einmalige Gratis-Bun-Aktion ist beendet. Danke fürs Mitfeiern!',
      unavailable: 'Die Aktion ist gerade nicht verfügbar. Bitte versuche es später erneut.'
    };
    const refresh = async () => {
      disable();
      state = await request('/status');
      if (state.campaignId !== 'soft-opening-2026-11-08' || !Object.hasOwn(messages, state.status)) throw new Error('UNAVAILABLE');
      message.textContent = messages[state.status];
      if (state.status === 'active' && typeof state.csrfToken === 'string' && Array.isArray(state.availableBuns)) {
        choices.forEach(button => { button.disabled = !state.availableBuns.includes(button.dataset.campaignChoice); });
      }
      const voucher = state.voucher;
      if (voucher?.orderId && voucher.reference && voucher.code && ['issued','redeemed'].includes(voucher.status)) {
        const result = container.querySelector('[data-campaign-result]');
        result.querySelector('[data-order-reference]').textContent = 'Bestellung: ' + voucher.reference;
        result.querySelector('[data-voucher-bun]').textContent = String(voucher.bun || '').toUpperCase() + ' BUN · 0,00 €';
        result.querySelector('[data-voucher-code]').textContent = voucher.code;
        result.querySelector('[data-voucher-state]').textContent = voucher.status === 'redeemed' ? 'Bereits eingelöst.' : 'Noch nicht eingelöst.';
        result.hidden = false;
      }
    };
    dialog.querySelector('[data-close-campaign]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => previousFocus?.focus());
    choices.forEach(button => button.addEventListener('click', () => {
      if (button.disabled || state?.status !== 'active') return;
      selected = button.dataset.campaignChoice;
      previousFocus = button;
      dialog.querySelector('[data-selected-bun]').textContent = selected.toUpperCase() + ' BUN';
      error.textContent = '';
      dialog.showModal();
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || !selected || state?.status !== 'active') return;
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = true;
      error.textContent = 'Verfügbarkeit wird geprüft …';
      let idempotencyKey;
      try {
        idempotencyKey = sessionStorage.getItem('bb-campaign-request');
        if (!idempotencyKey) { idempotencyKey = crypto.randomUUID(); sessionStorage.setItem('bb-campaign-request', idempotencyKey); }
      } catch { idempotencyKey = crypto.randomUUID(); }
      try {
        const data = await request('/claims', {
          method: 'POST', headers: {'Content-Type': 'application/json', 'X-CSRF-Token': state.csrfToken},
          body: JSON.stringify({campaignId: 'soft-opening-2026-11-08', bun: selected, email: form.elements.email.value.trim(), termsAccepted: true, idempotencyKey})
        });
        if (!['verify_email','checkout_required'].includes(data.status)) throw new Error('UNAVAILABLE');
        if (data.status === 'verify_email') {
          error.textContent = 'Bitte bestätige deine E-Mail-Adresse über den Link in deinem Postfach. Erst nach erfolgreicher Bestätigung und kostenloser Bestellung wird ein Voucher ausgestellt.';
          return;
        }
        const checkout = new URL(data.checkoutUrl, location.origin);
        if (checkout.origin !== location.origin || checkout.protocol !== 'https:' || !/^\/(checkouts?|cart)(\/|\?|$)/.test(checkout.pathname)) throw new Error('UNAVAILABLE');
        window.location.assign(checkout.href);
      } catch (failure) {
        const safeErrors = {SOLD_OUT:'Alle kostenlosen Buns sind inzwischen vergeben.',ALREADY_CLAIMED:'Für diese Teilnahme wurde bereits eine Bestellung angelegt. Bitte prüfe dein Postfach.',EXPIRED:'Die Aktion ist beendet.',NOT_STARTED:'Die Aktion hat noch nicht begonnen.',INVALID_EMAIL:'Bitte prüfe deine E-Mail-Adresse.',RATE_LIMITED:'Bitte warte einen Moment und versuche es erneut.'};
        error.textContent = safeErrors[failure.message] || 'Die Bestellung konnte nicht gestartet werden. Es wurde kein neuer Voucher ausgestellt. Bitte versuche es später erneut.';
        if (['SOLD_OUT','EXPIRED','NOT_STARTED'].includes(failure.message)) { state = null; disable(); }
      } finally { submit.disabled = false; }
    });
    try { await refresh(); } catch { disable(); message.textContent = messages.unavailable; }
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

